<template>
    <div
        :class="['field-holder', {
            'field-holder--alt' : isAlt
        }]"
    >
        <slot name="label" :label="label" :id="id">
            <label
                v-if="label"
                :for="id"
                class="form__label"
                v-html="label"
            />
        </slot>

        <div class="form__controls">
            <slot name="field" :id="id" :classes="['field', customClass]">
                <input v-if="required"
                    required
                    ref="field"
                    v-bind="$attrs"
                    :id="id"
                    :type="type"
                    :value="modelValue"
                    :class="['field', customClass]"
                    @input="$emit('update:modelValue', $event.target.value)"
                />
                <input v-else
                    ref="field"
                    v-bind="$attrs"
                    :id="id"
                    :type="type"
                    :value="modelValue"
                    :class="['field', customClass]"
                    @input="$emit('update:modelValue', $event.target.value)"
                />
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseInput',

    inheritAttrs: false,

    props: {
        modelValue: {
            type: [String, Number],
        },

        id: {
            type: [String, Number],
            required: true
        },
        type: {
            type: String,
            default: 'text',
        },
        label: {
            type: String,
            default: '',
        },
        customClass: {
            type: String,
            default: '',
        },
        isAlt: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
};
</script>
